import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Clipboard from 'clipboard';
import { connect } from 'react-redux';
import { StickyContainer, Sticky } from 'react-sticky';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { ButtonV2 } from '@zola/zola-ui';

import StickyHeaderTable from '../../common/ui/StickyHeaderTable';
import { showModal } from '../../../actions/ModalActions';
import { fetchEnvelopeList, toggleInvitationSent, toggleSaveTheDateSent, toggleEnvelopeFacetValue, toggleSortByNameAsc, fetchGuestList, getGuestGroup } from '../../../actions/GuestActions';
import Address from '../../common/ui/Address';
import GlobalStats from '../common/GlobalStats';
import Facets from './Facets';
import { PrefixToLabel } from './GuestListTypes';
import Loader from '../../common/ui/Loader';
import NoGuestsOnboardFormV2 from './noGuestsOnboardFormV2/NoGuestsOnboardFormV2';
import NoGuestValueProps from './noGuestValueProps/NoGuestValueProps';
import { isCompleteAddress, isMissingAddress, isNameUnknown, getIncompleteAddressGuestGroupIds } from './util';


class GuestGroupRow extends Component {
  constructor(props) {
    super(props);

    this.rowCheck = this.rowCheck.bind(this);
    this.rowClick = this.rowClick.bind(this);

    this.state = {
      active: false,
      timeout: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { modalOpen, onSelectGuestGroup } = this.props;
    if (modalOpen && (nextProps.modalOpen === false)) {
      this.setState({
        timeout: setTimeout(() => onSelectGuestGroup(null), 1000)
      });
    }
  }

  componentWillUnmount() {
    const { timeout } = this.state;
    if (timeout) {
      clearTimeout(timeout);
    }
  }

  rowCheck() {
    const { guestGroup, onRowCheck, isRowChecked } = this.props;
    onRowCheck(guestGroup.id, !isRowChecked);
  }

  rowClick(e) {
    const { guestGroup, onEditGuestGroup, onSelectGuestGroup } = this.props;
    if (e.target.hasAttribute('data-no-edit')) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    } else {
      onEditGuestGroup(guestGroup.id);
      onSelectGuestGroup(guestGroup.id);
    }
  }

  render() {
    const {
      guestGroup,
      isActive,
      onToggleInvitationSent,
      onToggleSaveTheDateSent,
      onSelectGuestGroup,
      isRowChecked,
      onRequestMissingInfo
    } = this.props;

    const [primaryGuest, ...otherGuests] = guestGroup.guests;

    const address = {
      address1: guestGroup.address_1,
      address2: guestGroup.address_2,
      city: guestGroup.city,
      state: guestGroup.state_province,
      zip: guestGroup.postal_code,
      countryCode: guestGroup.country_code
    };

    return (
      <tr
        className={isActive ? 'table-row table-row-active' : 'table-row'}
        onClick={this.rowClick}
        onMouseEnter={() => onSelectGuestGroup(guestGroup.id)}
      >
        <td>
          <div className="checkbox checkbox-table checkbox-secondary">
            <label htmlFor={`guests-${guestGroup.id}`} data-no-edit>
              <input
                type="checkbox"
                id={`guests-${guestGroup.id}`}
                data-no-edit
                checked={isRowChecked}
                onClick={this.rowCheck}
              />
              <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
            </label>
          </div>
        </td>
        <td className="guest-group-list">
          <div>{PrefixToLabel[primaryGuest.prefix]} {primaryGuest.first_name} <strong>{primaryGuest.family_name}</strong></div>
          <ul className="list-indent text-muted">
            {otherGuests.length > 0 && otherGuests.map(otherGuest => (
              <li key={otherGuest.id}>
                {isNameUnknown(otherGuest) ? (
                  <span>{otherGuest.relationship_type === 'CHILD' ? 'Child' : 'Guest'}</span>
                ) : (
                  <span>{PrefixToLabel[otherGuest.prefix]} {otherGuest.first_name} {otherGuest.family_name}</span>
                )}
              </li>
            ))}
          </ul>
        </td>
        <td className="mailing-address">
          <div className="text-pre"><strong>{guestGroup.envelope_recipient}</strong></div>
          {isCompleteAddress(address) ? (
            <Address {...address} />
          ) : (
            <div className="incomplete-mailing-address">
              <div className="text-danger">{isMissingAddress(address) ? 'Missing Address' : 'Incomplete Address'}</div>
              {guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  {(guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      {moment(guestGroup.collect_addresses_message_sent_at).isAfter(moment(guestGroup.collect_address_copied_at)) ? (
                        <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                      ) : (
                        <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                      )}
                    </div>
                  )}
                  {(guestGroup.collect_addresses_message_sent_at && !guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                  {(!guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                </div>
              )}
              {!guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  <div>
                    {guestGroup.collect_address_copied_at && (
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </td>
        <td>
          <div className="radio">
            <label htmlFor={`${guestGroup.id}-save-the-date-sent-yes`} data-no-edit>
              <input
                type="radio"
                id={`${guestGroup.id}-save-the-date-sent-yes`}
                checked={guestGroup.save_the_date_sent}
                onChange={() => onToggleSaveTheDateSent([guestGroup.id], true)}
                data-no-edit
              />
              <span className="input-override" data-no-edit />
              Yes
            </label>
          </div>
          <div className="radio" data-no-edit>
            <label htmlFor={`${guestGroup.id}-save-the-date-sent-no`} data-no-edit>
              <input
                type="radio"
                id={`${guestGroup.id}-save-the-date-sent-no`}
                checked={!guestGroup.save_the_date_sent}
                onChange={() => onToggleSaveTheDateSent([guestGroup.id], false)}
                data-no-edit
              />
              <span className="input-override" data-no-edit />
              No
            </label>
          </div>
        </td>
        <td>
          <div className="radio">
            <label htmlFor={`${guestGroup.id}-invitation-sent-yes`} data-no-edit>
              <input
                type="radio"
                id={`${guestGroup.id}-invitation-sent-yes`}
                checked={guestGroup.invitation_sent}
                onChange={() => onToggleInvitationSent([guestGroup.id], true)}
                data-no-edit
              />
              <span className="input-override" data-no-edit />
              Yes
            </label>
          </div>
          <div className="radio">
            <label htmlFor={`${guestGroup.id}-invitation-sent-no`} data-no-edit>
              <input
                type="radio"
                id={`${guestGroup.id}-invitation-sent-no`}
                checked={!guestGroup.invitation_sent}
                onChange={() => onToggleInvitationSent([guestGroup.id], false)}
                data-no-edit
              />
              <span className="input-override" data-no-edit />
              No
            </label>
          </div>
        </td>
      </tr>
    );
  }
}

GuestGroupRow.propTypes = {
  guestGroup: PropTypes.shape({}),
  onToggleInvitationSent: PropTypes.func.isRequired,
  onToggleSaveTheDateSent: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  isRowChecked: PropTypes.bool.isRequired,
  onRowCheck: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  onRequestMissingInfo: PropTypes.func.isRequired,
};

class AddressingHeader extends Component { // eslint-disable-line
  render() {
    const { checkAllRows, checkedAllRows, onToggleSort, sortByNameAsc, style } = this.props;
    return (
      <thead className="table-header" style={style}>
        <tr>
          <th className="td-checkbox">
            <div className="checkbox checkbox-table">
              <label htmlFor="guests-select-all">
                <input
                  type="checkbox"
                  id="guests-select-all"
                  onClick={checkAllRows}
                  checked={checkedAllRows}
                />
                <span className="input-override"><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Select all guests on this page."><i className="zolaicon zolaicon-checkmark" /></div></span>
              </label>
            </div>
          </th>
          <th className="sortable" role="button" onClick={onToggleSort}><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View guests by last name, ascending or descending."><span className="tooltip-span">Name<i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></span></div></th>
          <th>Address</th>
          <th>Save The Date Sent?</th>
          <th>Wedding Invitation Sent?</th>
        </tr>
      </thead>
    );
  }
}

AddressingHeader.defaults = {
  style: {}
};

AddressingHeader.propTypes = {
  checkAllRows: PropTypes.func.isRequired,
  checkedAllRows: PropTypes.bool.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  style: PropTypes.objectOf(PropTypes.string)
};

// must be a class component for sticky header to work properly
class AddressingTable extends Component { // eslint-disable-line
  render() {
    const {
      headerStyle,
      checkAllRows,
      checkedAllRows,
      onToggleSort,
      sortByNameAsc,
      filteredIds,
      guestGroups,
      selectedGuestGroupId,
      onToggleInvitationSent,
      onToggleSaveTheDateSent,
      onEditGuestGroup,
      onSelectGuestGroup,
      checkedRows,
      checkRow,
      editGuestModalOpen,
      onRequestMissingInfo,
      tableId,
    } = this.props;

    return (
      <table className="table guest-table-v2 table-fixed-header-round round-bottom" id={tableId}>
        <AddressingHeader
          checkAllRows={checkAllRows}
          checkedAllRows={checkedAllRows}
          onToggleSort={onToggleSort}
          sortByNameAsc={sortByNameAsc}
          style={headerStyle}
        />
        <tbody>
          {filteredIds.map(guestGroupId => (
            <GuestGroupRow
              key={guestGroupId}
              guestGroup={guestGroups[guestGroupId]}
              isActive={guestGroupId === selectedGuestGroupId}
              onToggleInvitationSent={onToggleInvitationSent}
              onToggleSaveTheDateSent={onToggleSaveTheDateSent}
              onEditGuestGroup={onEditGuestGroup}
              onSelectGuestGroup={onSelectGuestGroup}
              isRowChecked={_.includes(checkedRows, guestGroupId)}
              onRowCheck={checkRow}
              modalOpen={editGuestModalOpen}
              onRequestMissingInfo={onRequestMissingInfo}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

AddressingTable.defaults = {
  headerStyle: {},
  selectedGuestGroupId: null
};

AddressingTable.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  editGuestModalOpen: PropTypes.bool.isRequired,
  selectedGuestGroupId: PropTypes.number,
  filteredIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  guestGroups: PropTypes.shape({}).isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  checkRow: PropTypes.func.isRequired,
  checkAllRows: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  onRequestMissingInfo: PropTypes.func.isRequired,
  onToggleInvitationSent: PropTypes.func.isRequired,
  onToggleSaveTheDateSent: PropTypes.func.isRequired,
  tableId: PropTypes.string,
};

class EnvelopeAddressing extends Component {
  constructor(props) {
    super(props);

    this.checkRow = this.checkRow.bind(this);
    this.checkAllRows = this.checkAllRows.bind(this);
    this.unCheckAllRows = this.unCheckAllRows.bind(this);
    this.resetFacets = this.resetFacets.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.afterExport = this.afterExport.bind(this);
    this.showAllGuests = this.showAllGuests.bind(this);

    this.state = {
      checkedRows: [],
      checkedAllRows: false,
      clipboard: undefined
    };
  }

  componentDidMount() {
    const { getGuestList, getEvents, onSelectGuestGroup, getMostCurrentGuestList } = this.props;
    getGuestList().then(() => {
      const { guestGroupOrderedIds } = this.props;
      onSelectGuestGroup(guestGroupOrderedIds[0]);
    });
    this.initializeClipboard();
    getMostCurrentGuestList();
    getEvents();
  }

  componentWillReceiveProps(nextProps) {
    const { filteredIds } = nextProps;
    const { checkedRows } = this.state;

    const nextCheckedRows = _.intersection(checkedRows, filteredIds);
    const nextCheckedAllRows = nextCheckedRows.length !== 0 && nextCheckedRows.length === filteredIds.length;

    this.setState({
      checkedRows: nextCheckedRows,
      checkedAllRows: nextCheckedAllRows,
    });
  }

  componentWillUnmount() {
    const { onUnload } = this.props;
    onUnload();
    this.destroyClipboard();
    this.resetAll();
  }

  checkRow(id, isChecked) {
    const { filteredIds } = this.props;
    const { checkedRows } = this.state;

    if (isChecked) {
      checkedRows.push(id);
    } else {
      _.pull(checkedRows, id);
    }

    this.setState({
      checkedRows,
      checkedAllRows: filteredIds.length === checkedRows.length
    });
  }

  checkAllRows() {
    const { filteredIds } = this.props;
    const checkedAllState = !this.state.checkedAllRows;

    this.setState({
      checkedRows: checkedAllState ? filteredIds.slice() : [],
      checkedAllRows: checkedAllState
    });
  }

  unCheckAllRows() {
    this.setState({
      checkedRows: [],
      checkedAllRows: false
    });
  }

  initializeClipboard() {
    const clipboard = new Clipboard('.collect-address-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      target.setAttribute('data-tooltip', 'Copied!');
      setTimeout(() => {
        target.removeAttribute('data-tooltip');
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  afterExport() {
    const { onConfirmation } = this.props;
    this.exportDropdown.hide();
    onConfirmation('Guest Addresses Exported');
  }

  resetFacets() {
    const { onResetFacets, getGuestList } = this.props;
    onResetFacets();
    getGuestList();
  }

  resetAll() {
    const { onResetFacets, onResetSearchValue, onSelectGuestGroup } = this.props; // eslint-disable-line
    onResetSearchValue();
    // onResetFacets();
    onSelectGuestGroup(null);
  }

  showAllGuests() {
    const { onResetFacets, onResetSearchValue, getGuestList } = this.props;
    onResetSearchValue();
    onResetFacets();
    getGuestList();
  }

  render() {
    const {
      guestGroups,
      onToggleInvitationSent,
      onToggleSaveTheDateSent,
      onEditGuestGroup,
      onToggleFacet,
      globalStats,
      numGuests,
      numSelectedFacets,
      sortByNameAsc,
      onToggleSort,
      selectedFacetValues,
      onGuestMessage,
      editGuestModalOpen,
      initialized,
      onRequestMissingInfo,
      onSearchFilterGuestList,
      searchValue,
      filteredIds,
      onSelectGuestGroup,
      selectedGuestGroupId,
    } = this.props;

    const { checkedRows, checkedAllRows } = this.state;

    if (!initialized) {
      return (
        <div className="guestlist-loader">
          <Loader delay />
        </div>
      );
    }

    const formattedGlobalStats = globalStats.map((globalStat) => {
      if (globalStat.key === 'addresses_missing' && globalStat.value > 0) {
        return Object.assign({}, globalStat, { isLink: true, linkAttrs: { role: 'button', onClick: () => onRequestMissingInfo(getIncompleteAddressGuestGroupIds(guestGroups)) }, tooltip: 'We\'ll help you collect all of these. Click on "Missing Addresses" to begin.' });
      }
      return globalStat;
    });

    return (
      <div>
        {numGuests === 0 ? (
          <div>
            <NoGuestsOnboardFormV2 />
            <NoGuestValueProps />
          </div>
        ) : (
          <StickyContainer>
            <div>
              <div className="content-top">
                <div className="row">
                  <div className="col-xs-12 navbar-default">
                    <h1 className="page-heading col-xs-12 col-sm-6">Address Envelopes</h1>
                    <div className="nav navbar-nav navbar-right">
                      <ul className="list-inline">
                        <li className="with-tooltip" data-tooltip="Export your list in the format of these popular paper suppliers, so you can easily upload the file to their sites (no reformatting necessary).">
                          <Dropdown ref={(c) => { this.exportDropdown = c; }}>
                            <DropdownTrigger className="v2-button primary-button navbar-btn">Export Addresses <i className="zolaicon zolaicon-chevron-down" /></DropdownTrigger>
                            <DropdownContent className="">
                              <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/address-excel" onClick={this.afterExport}>Excel Format</a>
                                </li>
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/envelope" onClick={this.afterExport}>.csv Format</a>
                                </li>
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/text" onClick={this.afterExport}>Text Format</a>
                                </li>
                              </ul>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="global-stats-container address-envelopes-global-stats">
                      <ul className="nav navbar-nav navbar-left">
                        <li><GlobalStats stats={formattedGlobalStats} /></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-xs-12">
                    <div>
                      <div className={['guest-table main-content', filteredIds.length === 0 ? 'col-xs-12' : 'col-xs-12 col-md-9 col-lg-9'].join(' ')}>
                        <div className="navbar-default">
                          <div className="nav navbar-nav navbar-left">
                            {checkedRows.length > 0 ? (
                              <ul className="list-inline filter-search-ul-v2 address-envelopes-ul">
                                <li>
                                  <Dropdown ref={(c) => { this.bulkActionsDropdown = c; }}>
                                    <DropdownTrigger className="btn-dropdown btn-dropdown-secondary navbar-btn btn btn-boxed">
                                      <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Perform actions on multiple guests at once.">
                                        <span>Bulk Actions</span>
                                        <i className="zolaicon zolaicon-chevron-down" />
                                      </div>
                                    </DropdownTrigger>
                                    <DropdownContent>
                                      <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-left">
                                        <li>
                                          <a role="button" onClick={() => { onGuestMessage(checkedRows); this.bulkActionsDropdown.hide(); }}>Send Message</a>
                                        </li>
                                        <li>
                                          <a role="button" onClick={() => { onToggleSaveTheDateSent(checkedRows, true); this.bulkActionsDropdown.hide(); }}>Set &ldquo;Save The Date Sent?&rdquo; to Yes</a>
                                        </li>
                                        <li>
                                          <a role="button" onClick={() => { onToggleSaveTheDateSent(checkedRows, false); this.bulkActionsDropdown.hide(); }}>Set &ldquo;Save The Date Sent?&rdquo; to No</a>
                                        </li>
                                        <li>
                                          <a role="button" onClick={() => { onToggleInvitationSent(checkedRows, true); this.bulkActionsDropdown.hide(); }}>Set &ldquo;Wedding Invitation Sent?&rdquo; to Yes</a>
                                        </li>
                                        <li>
                                          <a role="button" onClick={() => { onToggleInvitationSent(checkedRows, false); this.bulkActionsDropdown.hide(); }}>Set &ldquo;Wedding Invitation Sent?&rdquo; to No</a>
                                        </li>
                                      </ul>
                                    </DropdownContent>
                                  </Dropdown>
                                </li>
                                <li>
                                  {checkedRows.length} Selected. <a role="button" onClick={this.unCheckAllRows}>Clear Selection</a>
                                </li>
                              </ul>
                            ) : (
                              <ul className="list-inline filter-search-ul-v2 address-envelopes-ul">
                                <li>
                                  <Dropdown>
                                    <DropdownTrigger className="btn-dropdown navbar-btn btn btn-boxed">
                                      {numSelectedFacets
                                        ? <span>{numSelectedFacets} Filters Selected</span>
                                        : <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View specific groups of guests and perform bulk actions."><span>Filter Guests ({numGuests})</span></div>
                                      }
                                      <i className="zolaicon zolaicon-chevron-down" />
                                    </DropdownTrigger>
                                    <DropdownContent className="">
                                      <div className="dropdown-menu dropdown-menu-left">
                                        <Facets selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={this.resetFacets} />
                                      </div>
                                    </DropdownContent>
                                  </Dropdown>
                                </li>
                                <li>
                                  <div className="has-feedback has-feedback-left">
                                    <span className="zolaicon clear-search hidden" />
                                    <i className="glyphicon glyphicon-search form-control-feedback hidden-xs hidden-sm" />
                                    <input
                                      className="form-control search"
                                      type="search"
                                      placeholder="Search Guest List"
                                      onChange={e => onSearchFilterGuestList(e)}
                                      value={searchValue}
                                    />
                                  </div>
                                </li>
                              </ul>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          {filteredIds.length === 0 ? (
                            <div className="col-xs-12 text-center">
                              <h3>No Results Found</h3>
                              <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                              <ButtonV2 className="margin-top-2x" onClick={this.showAllGuests}>Show All Guests</ButtonV2>
                            </div>
                          ) : (
                            <StickyHeaderTable
                              StaticTable={AddressingTable}
                              StickyHeader={AddressingHeader}
                              dataPropName="guestGroups"
                              stickyHeaderCls="table guest-table-v2"
                              filteredIds={filteredIds}
                              guestGroups={guestGroups}
                              selectedGuestGroupId={selectedGuestGroupId}
                              onToggleInvitationSent={onToggleInvitationSent}
                              onToggleSaveTheDateSent={onToggleSaveTheDateSent}
                              onEditGuestGroup={onEditGuestGroup}
                              onSelectGuestGroup={onSelectGuestGroup}
                              checkedRows={checkedRows}
                              checkRow={this.checkRow}
                              editGuestModalOpen={editGuestModalOpen}
                              onRequestMissingInfo={onRequestMissingInfo}
                              checkAllRows={this.checkAllRows}
                              checkedAllRows={checkedAllRows}
                              onToggleSort={onToggleSort}
                              sortByNameAsc={sortByNameAsc}
                              noStickyContainer
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {filteredIds.length === 0 ? (
                      <div />
                    ) : (
                      <div className="hidden-xs hidden-sm col-md-3 col-lg-3">
                        <Sticky className="envelope-preview-pane text-center" topOffset={-100} stickyStyle={{ top: 110 }}>
                          <h3 className="margin-bottom-2x">We&apos;re Here To Help</h3>
                          <p className="small margin-top-2x">Hover over any guest to see how their wedding invitation should be addressed.</p>
                          <p className="small margin-bottom-2x">Then tap the button above to export the list of addresses, so you can send it to your paper supplier or calligrapher.</p>
                          {selectedGuestGroupId && guestGroups[selectedGuestGroupId] && (
                            <div className="envelope-preview">
                              <div className="inner-envelope">
                                <div className="text-pre"><strong>{guestGroups[selectedGuestGroupId].envelope_recipient}</strong></div>
                                {isCompleteAddress({
                                  address1: guestGroups[selectedGuestGroupId].address_1,
                                  address2: guestGroups[selectedGuestGroupId].address_2,
                                  city: guestGroups[selectedGuestGroupId].city,
                                  state: guestGroups[selectedGuestGroupId].state_province,
                                  zip: guestGroups[selectedGuestGroupId].postal_code,
                                  countryCode: guestGroups[selectedGuestGroupId].country_code
                                }) && (
                                  <Address
                                    address1={guestGroups[selectedGuestGroupId].address_1}
                                    address2={guestGroups[selectedGuestGroupId].address_2}
                                    city={guestGroups[selectedGuestGroupId].city}
                                    state={guestGroups[selectedGuestGroupId].state_province}
                                    zip={guestGroups[selectedGuestGroupId].postal_code}
                                    countryCode={guestGroups[selectedGuestGroupId].country_code}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </Sticky>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </StickyContainer>
        )}
      </div>
    );
  }
}

EnvelopeAddressing.propTypes = {
  getGuestList: PropTypes.func.isRequired,
  onToggleInvitationSent: PropTypes.func.isRequired,
  onToggleSaveTheDateSent: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  guestGroups: PropTypes.shape({}),
  guestGroupOrderedIds: PropTypes.arrayOf(PropTypes.number),
  globalStats: PropTypes.arrayOf(PropTypes.shape({})),
  numGuests: PropTypes.number,
  numSelectedFacets: PropTypes.number,
  onToggleFacet: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool,
  onToggleSort: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  onGuestMessage: PropTypes.func.isRequired,
  onUnload: PropTypes.func.isRequired,
  editGuestModalOpen: PropTypes.bool,
  initialized: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onRequestMissingInfo: PropTypes.func,
  getEvents: PropTypes.func,
  onSearchFilterGuestList: PropTypes.func,
  searchValue: PropTypes.string,
  filteredIds: PropTypes.arrayOf(PropTypes.number),
  onResetSearchValue: PropTypes.func,
  onSelectGuestGroup: PropTypes.func,
  selectedGuestGroupId: PropTypes.number,
  getMostCurrentGuestList: PropTypes.func
};

const mapStateToProps = state => ({
  weddingAccount: state.wedding.account,
});

const mapDispatchToProps = dispatch => ({
  getGuestList: () => dispatch(fetchEnvelopeList()),
  getMostCurrentGuestList: () => dispatch(fetchGuestList()),
  onEditGuestGroup: (guestGroupId) => {
    const callback = () => dispatch(fetchEnvelopeList());
    return dispatch(getGuestGroup(guestGroupId))
      .then(() => dispatch(showModal('EDIT_GUEST_GROUP_WEDDING', { guestGroupId, activeTab: 'GUESTS', callback, formIdentifier: 'editGuestGroupForm' })));
  },
  onToggleInvitationSent: (ids, isSent) => dispatch(toggleInvitationSent(ids, isSent, fetchEnvelopeList)),
  onToggleSaveTheDateSent: (ids, isSent) => dispatch(toggleSaveTheDateSent(ids, isSent, fetchEnvelopeList)),
  onToggleFacet: (facetKey, facetValue) => dispatch(toggleEnvelopeFacetValue(facetKey, facetValue)),
  onToggleSort: () => {
    dispatch(toggleSortByNameAsc());
    dispatch(fetchEnvelopeList());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnvelopeAddressing);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/AddressEnvelopes.jsx